var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40 43h-13a1 1 0 0 1 0-2h13a1 1 0 0 1 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40 43h-13a5.006 5.006 0 0 1 -5-5v-4a5.006 5.006 0 0 1 5-5h10a5.006 5.006 0 0 1 5 5 1 1 0 0 1 -2 0 3 3 0 0 0 -3-3h-10a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3h13a1 1 0 0 1 0 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m37 55h-10a5.006 5.006 0 0 1 -5-5 1 1 0 0 1 2 0 3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-4a1 1 0 0 1 2 0v4a5.006 5.006 0 0 1 -5 5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41 48a1 1 0 0 1 -1-1v-13a1 1 0 0 1 2 0v13a1 1 0 0 1 -1 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m47 9h-28a1 1 0 0 1 0-2h28a1 1 0 0 1 0 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m56 64h-48a8.009 8.009 0 0 1 -8-8v-41a8 8 0 0 1 8-8h2a1 1 0 0 1 0 2h-2a6 6 0 0 0 -6 6v41a6.006 6.006 0 0 0 6 6h48a6.006 6.006 0 0 0 6-6v-41a6.006 6.006 0 0 0 -6-6 1 1 0 0 1 0-2 8.009 8.009 0 0 1 8 8v41a8.009 8.009 0 0 1 -8 8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m47 9h-28a1 1 0 0 1 0-2h28a1 1 0 0 1 0 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m14.5 16a5.506 5.506 0 0 1 -5.5-5.5v-5a5.5 5.5 0 0 1 11 0v5a5.506 5.506 0 0 1 -5.5 5.5zm0-14a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 7 0v-5a3.5 3.5 0 0 0 -3.5-3.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m51.5 16a5.506 5.506 0 0 1 -5.5-5.5v-5a5.5 5.5 0 0 1 11 0v5a5.506 5.506 0 0 1 -5.5 5.5zm0-14a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 7 0v-5a3.5 3.5 0 0 0 -3.5-3.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m63 23h-62a1 1 0 0 1 0-2h62a1 1 0 0 1 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e3609f69a2a7583a6e0f42ddeb2479e2.svg";
export { ForwardRef as ReactComponent };